import React, { useEffect } from "react";
import Select from "react-select";

const CustomSelect = ({ label, className, options, value, onChange, clear }) => {
    // Limpar o select quando a prop `clear` mudar
    useEffect(() => {
        if (clear) {
            onChange(null);  // Chama onChange com `null` para limpar o valor externo
        }
    }, [clear, onChange]);

    const handleChange = (option) => {
        onChange(option ? option.value : null);  // Define como `null` se vazio
    };

    return (
        <div className={className}>
            <div className="form-group">
                <label>{label}</label>
                <Select
                    options={options.map((item) => ({
                        value: item.id, // ID como valor
                        label: item.name, // Nome exibido
                    }))}
                    value={
                        value
                            ? {
                                value: value,
                                label: options.find(option => option.id === value)?.name || "",
                            }
                            : null
                    }  // Passa null se `value` estiver vazio
                    onChange={handleChange}
                    placeholder={`Selecione`}
                    isClearable
                    styles={{
                        control: (provided) => ({
                            ...provided,
                            width: "100%",
                        }),
                    }}
                    menuPortalTarget={document.body} // Renderiza o menu fora do contêiner pai
                    styles={{
                        menuPortal: base => ({
                            ...base,
                            zIndex: 9999
                        }), // Definindo z-index alto
                        menu: base => ({...base, zIndex: 9999}) // Ajuste de z-index no próprio menu
                    }}
                />
            </div>
        </div>
    );
};

export default CustomSelect;
